import { createAction, props } from '@ngrx/store';
import { TestModel } from '../models/test-model.model';

export const setTestModels = createAction('[Invite Component] SetTestModels', props<{ testModels: TestModel[] }>());
